import { render, staticRenderFns } from "./GenericListedMovies.vue?vue&type=template&id=5dbacee1"
import script from "./GenericListedMovies.vue?vue&type=script&lang=js"
export * from "./GenericListedMovies.vue?vue&type=script&lang=js"
import style0 from "./GenericListedMovies.vue?vue&type=style&index=0&id=5dbacee1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports